export default "__VITE_ASSET__C32G8RRL__"